"use strict";

import React from "react";

import dispatcher from "./../../dispatcher";
import poiStore from "./../../store/pois";
import openedDetailsStore from "./../../store/openedDetails";

import shouldComponentUpdate from "vwa/shouldComponentUpdate";

import Details from "vwa/components/Details";
import Pager from "vwa/components/Pager";
import POIProperties from "./../POIProperties";
import POICollaborators from "./../POICollaborators";
import lang from "vwa/lang";
import EEP from "vfu/EEP";
import getServiceSet from "vfu/getServiceSet";

export default class POIDetails extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
		this.eep = new EEP();
		this.setStoreListeners();
	}
	
	initState() {
		this.state = {
			poi: poiStore.get(this.props.poiId),
			page: openedDetailsStore.get(this.props.poiId).activePage
		};
	}
	
	setStoreListeners() {
		this.eep.on(poiStore, "update", poi => {
			if (poi._id == this.props.poiId)
				this.setState({poi});
		});
		
		this.eep.on(openedDetailsStore, "update", detailsDescriptor => {
			if (detailsDescriptor.id == this.props.poiId)
				this.setState({page: detailsDescriptor.activePage});
		});
	}
	
	shouldComponentUpdate(...nexts){
		return shouldComponentUpdate(this, ...nexts);
	}
	
	componentWillUnmount() {
		this.eep.close();
	}
	
	render() {
		
		const tabs = [
			{id: "properties", label: lang.PROPERTIES},
			{id: "collaborators", label: lang.COLLABORATORS}
		];
		
		const detailsProps = {
			title: this.state.poi.name || "",
			onClose: () => dispatcher.dispatch('closeDetails', "POIDetails", this.props.poiId),
			tabs: tabs,
			onTabChange: tabId => dispatcher.dispatch('switchDetailsPage', this.props.poiId, tabId),
			activeTab: this.state.page,
			dragable: true,
			ondrag: this.props.ondrag,
			className: this.props.className
		}
		
		return(
			<Details {...detailsProps}>
				<Pager active={this.state.page}>
					<div id="properties">
						<POIProperties poiId={this.props.poiId}/>
					</div>
					<div id="collaborators">
						<POICollaborators poiId={this.props.poiId}/>
					</div>
				</Pager>
			</Details>
		);
	}
	
}

POIDetails.propTypes = {
	poiId: React.PropTypes.string,
	ondrag: React.PropTypes.func
};

POIDetails.defaultProps = {
	poiId: null,
	ondrag: dragEvt => {}
};


// WEBPACK FOOTER //
// ./src/view/POIDetails/POIDetails.jsx